import { AudiencePage } from "@/components/audience-page";
import { FOR_PROFESSIONALS_FAQ_KEYS } from "@/pages/for-professionals-content";

export function ForProfessionalsComponent() {
  return (
    <AudiencePage audience="professionals" faqs={FOR_PROFESSIONALS_FAQ_KEYS} />
  );
}
